import { IconProps } from './icons-props';

function PenIcon({ className, width = 15, height = 15 }: IconProps) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox='0 0 15 15'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M13.9092 3.68056C13.8928 3.57731 13.7272 2.64981 13.0552 1.97256C12.3803 1.31223 11.4493 1.14889 11.3454 1.13256C11.2072 1.10981 11.066 1.13898 10.9476 1.21248C10.9062 1.23814 10.2978 1.61906 9.09668 2.63464C9.71443 2.85281 10.513 3.23139 11.1605 3.86489C11.8103 4.50073 12.1988 5.28298 12.4217 5.88964C13.425 4.71714 13.8024 4.12331 13.8275 4.08248C13.9022 3.96289 13.9313 3.81998 13.9092 3.68056Z'
                fill='currentColor'
            />
            <path
                d='M8.05435 3.54688C7.42844 4.11154 6.69985 4.79754 5.86568 5.62587C2.32893 9.13754 1.40143 10.5416 1.36352 10.5994C1.31043 10.681 1.27835 10.775 1.27077 10.8718L1.08468 13.2465C1.07185 13.4169 1.1331 13.5837 1.25385 13.7045C1.36352 13.8141 1.51227 13.8754 1.66685 13.8754C1.68143 13.8754 1.6966 13.8754 1.71177 13.8736L4.10402 13.6893C4.20027 13.6817 4.29302 13.6508 4.3741 13.5989C4.43243 13.5615 5.84585 12.6405 9.38202 9.12937C10.2349 8.28237 10.9384 7.54504 11.5141 6.91446C11.426 6.53587 11.1186 5.45554 10.3445 4.69896C9.55935 3.93071 8.43002 3.62971 8.05435 3.54688Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default PenIcon;

